import { Component, Inject } from '@angular/core'
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog'

@Component({
  selector: 'app-loading-dialog',
  templateUrl: './three-buttons-dialog.component.html',
  styleUrls: [
    './three-buttons-dialog.component.css',
    '../../../stylesheets/dialogs/dialogstylesheet.css'
  ]
})
export class ThreeButtonsDialogComponent {
  title: string = ''
  desc: string = ''
  button1Text: string = ''
  button2Text: string = ''
  button3Text: string = ''
  clickCallbackButton1: () => any = () => {}
  clickCallbackButton2: () => any = () => {}
  clickCallbackButton3: () => any = () => {}

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<ThreeButtonsDialogComponent>
  ) {
    this.title = data.title
    this.desc = data.desc
    this.clickCallbackButton1 = data.clickCallbackButton1
    this.clickCallbackButton2 = data.clickCallbackButton2
    this.clickCallbackButton3 = data.clickCallbackButton3
    this.button1Text = data.button1Text
    this.button2Text = data.button2Text
    this.button3Text = data.button3Text
  }

  onButton1Click(): void {
    this.dialogRef.close()
    this.clickCallbackButton1()
  }

  onButton2Click(): void {
    this.dialogRef.close()
    this.clickCallbackButton2()
  }

  onButton3Click(): void {
    this.dialogRef.close()
    this.clickCallbackButton3()
  }
}
